import React from "react";
import { Avatar, Tooltip } from "@mui/material";

const initialFor = (email) => {
  if (!email) return "?";
  const local = String(email).split("@")[0] || email;
  return local.charAt(0).toUpperCase();
};

const colorFor = (email) => {
  if (!email) return "#9e9e9e";
  let h = 0;
  for (let i = 0; i < email.length; i++) h = (h * 31 + email.charCodeAt(i)) & 0xffffffff;
  const hue = Math.abs(h) % 360;
  return `hsl(${hue}, 55%, 45%)`;
};

export default function UserAvatar({ email, size = 28, sx }) {
  return (
    <Tooltip title={email || "(no user)"} arrow>
      <Avatar
        sx={{
          width: size,
          height: size,
          fontSize: Math.round(size * 0.46),
          bgcolor: colorFor(email),
          mx: "auto",
          ...sx,
        }}
      >
        {initialFor(email)}
      </Avatar>
    </Tooltip>
  );
}
